export default __webpack_public_path__ + "3bcb35c845f65f171c0dc6fd0ea3167c.png";